import { Box, Typography, Slider } from '@mui/material';

function Metrics({ stability, mobility }) {
    return (
        <Box sx={{ mx: 2 }}>
            <Box sx={{ mb: 2 }}>
                                    <Typography variant="body1" sx={{ color: '#666', mb: 1 }}>Stability: {stability}/10</Typography>
                                    <Slider
                                        value={parseInt(stability) || 0}
                                        min={1}
                                        max={10}
                                        step={1}
                                        marks={[
                                            { value: 1, label: 'Low' },
                                            { value: 5, label: 'Medium' },
                                            { value: 10, label: 'High' }
                                        ]}
                                        sx={{
                                            mb: 5,
                                            '& .MuiSlider-markLabel': {
                                                fontSize: '0.75rem',
                                                color: '#888'
                                            },
                                            '& .MuiSlider-track': {
                                                backgroundColor: '#1976d2'
                                            },
                                            '& .MuiSlider-thumb': {
                                                backgroundColor: '#1976d2'
                                            }
                                        }}
                                        disabled
                                    />
                  
                        <Typography variant="body1" sx={{ color: '#666', mb: 1 }}>Mobility: {mobility}/10</Typography>
                    <Slider
                      value={parseInt(mobility) || 0}
                      min={1}
                      max={10}
                      step={1}
                      marks={[
                        { value: 1, label: 'Low' },
                        { value: 5, label: 'Medium' },
                        { value: 10, label: 'High' }
                      ]}
                      sx={{
                        '& .MuiSlider-markLabel': {
                          fontSize: '0.75rem',
                          color: '#888'
                        },
                        '& .MuiSlider-track': {
                          backgroundColor: '#2e7d32'
                        },
                        '& .MuiSlider-thumb': {
                          backgroundColor: '#2e7d32'
                        }
                      }}
                      disabled
                    />
        </Box>
        </Box>
    )
}

export default Metrics; 